<template>
  <div class="box">
    <h3>{{name}}</h3>
    <p>详情请下载查看</p>
    <a :href="path">点击下载</a>


  </div>
</template>

<script>
  export default {
    name: "zwPage",
    data() {
      return {
        val: '',
        path: '',
        name: ''
      }
    },
    mounted() {


      if (this.$route.params.path) {
        this.path = this.$route.params.path
        sessionStorage.setItem('path', this.$route.params.path)
      } else {
        this.path = sessionStorage.getItem('path')
      }

      this.path = '../../rsda/resource/static/files/' + this.path + '.docx';

      if (this.$route.params.name) {
        this.name = this.$route.params.name
        sessionStorage.setItem('name', this.$route.params.name)
      } else {
        this.name = sessionStorage.getItem('name')
      }
    }

  }
</script>

<style scoped>


  .box {
    padding: 10vw;
    box-sizing: border-box;
    font-size: 16px;
  }

  h3 {
    text-align: center;
    line-height: 50px;
  }

  p {
    margin: 20px auto;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/zwPage.vue